"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pngDataURIToBlob;
/*eslint-disable */
// helper function to convert URL to blob
function pngDataURIToBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString = void 0;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(dataURI.split(",")[1]);
    } else {
        byteString = encodeURI(dataURI.split(",")[1]);
    }
    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    console.log(mimeString);
    if (mimeString.indexOf("image") >= 0 && (mimeString.indexOf("png") >= 0 || mimeString.indexOf("jpeg") >= 0 || mimeString.indexOf("jpg") >= 0)) {
        return new Blob([ia], { type: mimeString });
    } else if (mimeString.indexOf("application/pdf") >= 0) {
        return new Blob([ia], { type: mimeString });
    } else {
        throw new Error("Filetype is not supported! " + mimeString);
    }
}
/*eslint-enable */
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/pngDataURIToBlob.ts
 ** module id = 1312
 ** module chunks = 0
 **/